import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  additionalMessageSpacing: {
    '&[data-field-error="true"]': {
      marginTop: 34,
      marginBottom: 24,
    },
  },
  rowContent: {
    display: 'flex',
    alignItems: 'flex-start',
    position: 'relative',
    flexDirection: 'column',
  },
}));
